import React, { createContext, useContext, useEffect, useState } from 'react';
import featuresService from '../services/featuresService';

/**
 * Deployment feature switches, fetched once at boot from /api/public/features.
 *
 * Before the answer arrives every flag reads false, so nothing gated ever
 * flashes into the nav on a deployment that has the feature off. `loaded` says
 * whether that false is an answer or just the default — routes must wait for
 * it before redirecting, or a dev user would be bounced on first render.
 */
const DEFAULTS = { listings: false };

const FeaturesContext = createContext({ ...DEFAULTS, loaded: false });

export const useFeatures = () => useContext(FeaturesContext);

export const FeaturesProvider = ({ children }) => {
  const [state, setState] = useState({ ...DEFAULTS, loaded: false });

  useEffect(() => {
    let cancelled = false;
    featuresService
      .get()
      .then((res) => {
        if (cancelled) return;
        setState({ ...DEFAULTS, ...(res?.data || {}), loaded: true });
      })
      .catch(() => {
        // An unreachable API must not unlock anything: stay on the defaults,
        // but mark it settled so gated routes resolve to Not Found instead of
        // spinning forever.
        if (!cancelled) setState({ ...DEFAULTS, loaded: true });
      });
    return () => { cancelled = true; };
  }, []);

  return <FeaturesContext.Provider value={state}>{children}</FeaturesContext.Provider>;
};

export default FeaturesContext;
